/***********************
 * HERO STATS
 */

import { PartnerHeroStats } from '../graphTypes';

export type HeroStatType = {
  label?: string;
  id?: string;
  value?: number;
  secondaryValue?: number;
  status?: string;
  ready?: boolean;
  unit?: string;
  valueId?: string; // Used for New Relic monitoring
  tooltipText?: string;
  undefinedText?: string;
};

export const emptyHeroStats: HeroStatType[] = [{}, {}, {}, {}, {}];

export type HeroStatsTypicalType = {
  latest_typical_stats: [
    {
      average_health_score: number;
    },
  ];
};

export type HeroStatsLatestType = {
  latest_partner_stats: [
    {
      average_health_score: number;
      location_count: number;
      any_severity_location_count: number;
      maximum_severity_location_count: number;
    },
  ];
};

export type HeroStatsRecentPartner = {
  recent_partner_stats: [
    {
      average_health_score: number;
      maximum_severity_location_count: number;
    },
  ];
};

export const statEmpty: HeroStatType = {
  label: 'xxx',
  value: undefined,
  valueId: 'error',
};

const OVERRIDE_locationCount = 100000;
const useOverride = false;

export const getEmptyStat = (label: string): HeroStatType => {
  return {
    label: label,
    value: undefined,
    valueId: 'error',
    undefinedText:
      label === 'heroStats.suppressedOfflineLocations' ? 'N/A' : undefined,
  };
};

export const makeHeroStats = (
  typical: any,
  latest: PartnerHeroStats[],
  t: (a: string) => string,
): HeroStatType[] => {
  let heroStatParsed: HeroStatType[] = [];
  let activeLocationCount = 0;
  if (latest[0] && latest[0].location_count) {
    activeLocationCount = latest[0].location_count;
  } else {
    console.warn('!!!! WARNING !!! No latest data for location_count');
  }

  if (useOverride) {
    activeLocationCount = OVERRIDE_locationCount;
    console.warn(
      '!!!! WARNING !!!!  Using OVERRIDE_locationCount; should ONLY be for DEV',
    );
  }
  if (latest && latest[0] && activeLocationCount > 0) {
    heroStatParsed.push({
      label: 'heroStats.avgHealthScore',
      value: latest[0]?.average_health_score,
      valueId: 'heroStats_avgHealthScore',
      tooltipText: t('healthSummary.hero.networkHealth.tooltipText'),
    });
  }

  if (typical && typical[0]) {
    heroStatParsed.push({
      label: 'heroStats.typHealthScore',
      value: typical[0]?.average_health_score,
      valueId: 'heroStats_typicalHealthScore',
    });
  } else {
    console.error('SIGNAL INTERNAL: Unable to parse heroStats.typical');
    return [];
  }

  if (latest && latest[0] && activeLocationCount > 0) {
    heroStatParsed.push({
      label: 'heroStats.locationsWithCriticalIssues',
      value: latest[0]?.maximum_severity_location_count * 100,
      unit: '%',
      secondaryValue:
        latest[0]?.maximum_severity_location_count * activeLocationCount,
      valueId: 'heroStats_locationsWithCriticalIssues',
      tooltipText: t(
        'healthSummary.hero.locationsWithCriticalIssues.tooltipText',
      ),
    });

    heroStatParsed.push({
      label: 'heroStats.locationsWithNonCriticalIssues',
      value:
        (latest[0].any_severity_location_count -
          latest[0].maximum_severity_location_count) *
        100,
      unit: '%',
      secondaryValue:
        (latest[0].any_severity_location_count -
          latest[0].maximum_severity_location_count) *
        activeLocationCount,
      valueId: 'heroStats_locationsWithIssues',
      tooltipText: t(
        'healthSummary.hero.locationsWithNonCriticalIssues.tooltipText',
      ),
    });

    heroStatParsed.push({
      label: 'heroStats.suppressedOfflineLocations',
      value: latest[0].suppressed_location_count,
      unit: '',
      valueId: 'heroStats_suppressedOfflineLocations',
      tooltipText: t(
        'healthSummary.hero.suppressedOfflineLocations.tooltipText',
      ),
      undefinedText: 'N/A',
    });
  } else {
    console.error('SIGNAL INTERNAL: Unable to parse heroStats.latest');
    return [];
  }
  return heroStatParsed;
};
